import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { PicPayload, PicResponse } from "@/types/interface/pic";

async function createPic(payload: PicPayload) {
  return await http.post<APIResponse<PicResponse>>("pic/create", payload);
}

async function updatePic(idPic = '', payload: PicPayload) {
  return await http.patch<APIResponse<PicResponse>>(`pic/update?id=${idPic}`, payload);
}

async function getPic(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<PicResponse>>(`pic?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findPic(idPic = "") {
  return await http.get<APIResponse<PicResponse>>(`pic/detail?id=${idPic}`);
}

async function deletePic(idPic = "") {
  return await http.delete<APIResponse<PicResponse>>(`pic/delete?id=${idPic}`);
}

export default {
  createPic,
  updatePic,
  getPic,
  findPic,
  deletePic
};